import { IPagingResponse } from '.';

export const formatPagingResponse = (response: IPagingResponse): IPagingResponse => ({
    pageNumber: response.pageNumber > 0 ? response.pageNumber : 1,
    pageSize: response.pageSize,
    totalItems: response.totalItems,
    totalPages: response.totalPages
});
